var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAviationOverlayColorfulVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 707,
    height: 154,
    viewBox: "0 0 707 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 147.627C225.5 71.7939 710.6 -55.7728 863 40.6272",
    stroke: "url(#paint0_linear_2459_25181)",
    strokeWidth: 12,
    strokeDasharray: "40 40"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2459_25181",
    x1: 1.99999,
    y1: 148,
    x2: 680,
    y2: 5.99995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviationOverlayColorfulVector2);
export default __webpack_public_path__ + "static/media/aviation-overlay-colorful-vector-2.9a9a6f53b393b9273c603ce3ee892af6.svg";
export { ForwardRef as ReactComponent };